import type { Series } from '../../shared/ui/charts/legend'

export const SOURCE_SERIES: readonly Series[] = [
  { key: 'web', label: 'Веб', color: 'var(--series-1)' },
  { key: 'telegram_bot', label: 'Telegram-бот', color: 'var(--series-2)' },
  { key: 'telegram_mini_app', label: 'Mini App', color: 'var(--series-3)' },
  { key: 'mobile', label: 'Мобильное', color: 'var(--series-4)' },
  { key: 'admin', label: 'Админка', color: 'var(--series-5)' },
]

export const PURPOSE_LABELS: Readonly<Record<string, string>> = {
  'daily-reading': 'Расклад дня',
  'daily-card-reading': 'Карта дня эксперта',
  'personal-arcana': 'Личный аркан',
  trainer: 'Тренировка',
  studio: 'Студия',
  'studio-chat': 'Студия: чат',
  chat: 'Чат',
}

const PURPOSE_COLORS = ['var(--series-1)', 'var(--series-2)', 'var(--series-3)', 'var(--series-4)', 'var(--series-5)']

export function purposeSeries(purposes: readonly string[]): Series[] {
  return [...new Set(purposes)].sort().map((key, i) => ({
    key,
    label: PURPOSE_LABELS[key] ?? key,
    color: PURPOSE_COLORS[i] ?? 'var(--muted-dim)',
  }))
}

export function indexBy<T extends { day: string }>(rows: readonly T[], key: (r: T) => string, value: (r: T) => number) {
  const map = new Map<string, number>()
  for (const r of rows) map.set(`${r.day}|${key(r)}`, (map.get(`${r.day}|${key(r)}`) ?? 0) + value(r))
  return (day: string, k: string) => map.get(`${day}|${k}`) ?? 0
}

export function percent(part: number, whole: number): string {
  return whole > 0 ? `${Math.round((part / whole) * 100)}%` : '—'
}
